import {
    CHANGE_ADDRESS_BUTTON_ID,
    CHANGE_PAYMENT_BUTTON_ID,
} from 'desktop/pages/checkout/constants/amazon';

/**
 * Function that binds amazon buttons so that the user can change his address/payment method
 * @param {string} sessionId - sessionId
 */
export const bindAmazonButtons = (sessionId: string) => {
    if (!window.amazon) return;

    window.amazon.Pay?.bindChangeAction(`#${CHANGE_ADDRESS_BUTTON_ID}`, {
        amazonCheckoutSessionId: sessionId,
        changeAction: 'changeAddress',
    });

    window.amazon.Pay?.bindChangeAction(`#${CHANGE_PAYMENT_BUTTON_ID}`, {
        amazonCheckoutSessionId: sessionId,
        changeAction: 'changePayment',
    });
};
